import { toast } from 'react-toastify';

import { createLog } from 'services/logService';

export const handleApiError = (error) => {
  toast.error(
    error?.response?.data || error?.response?.statusText || error?.message,
    {
      autoClose: 20000,
      position: 'bottom-left',
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    }
  );

  createLog(error);
};
